export default "__VITE_ASSET__D7vq7xjF__"